import arrow from './arrow.png';
import apple_store_icon from './apple_store_icon.png';
import android_market_icon from './android_market_icon.png';
import google_play_icon from './google_play_icon.png';
import download_icon from './download_icon.png';
import './App.css';
import * as React from "react";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            appName: 'YouthHealth',
            language: (navigator.language || navigator.browserLanguage).toLowerCase().indexOf("zh-cn") > 0 ? "zh-cn" : (navigator.language || navigator.browserLanguage).toLowerCase().indexOf("zh-tw") > 0 ? "zh-tw" : 'en',
            isWeChatBrowser: !!window.navigator.userAgent.toLowerCase().match("micromessenger"),
            googlePlayUrl: '',
            defaultGooglePlayUrl: 'https://play.google.com/store/apps/details?id=com.jinyichen.healthday',
            appMarketUrl: '',
            defaultAppMarketUrl: 'https://imtt.dd.qq.com/16891/apk/8295C5D745E09A577050246B97E27C08.apk?fsname=com.jinyichen.healthday_3.3.3_1415.apk&amp;csr=1bbd',
            appStoreUrl: 'https://apps.apple.com/cn/app/youth-health/id1481435412',
            isDownload: false,
            isLoading: false,
        }
    }

    handleDownload(e) {
        const that = this;
        let url = e.target.dataset["url"] || e.target.parentNode.dataset["url"];
        console.log(url);
        if (!!url) {
            that.setState({isDownload: true});
            setTimeout(() => that.setState({isDownload: false}), 10000);
            window.location.href = url;
        } else {
            alert("获取下载链接失败");
        }
    }

    componentDidMount() {
        this.initConfig();
    }

    initConfig() {
        let location = window.location.href;
        location = location.replace("/index.html", "/config.json")
            .replace("/index", "/config.json");
        if (location.endsWith("/")) {
            location = location + "config.json";
        }
        const that = this;
        let xhr = new XMLHttpRequest();
        const appMarketUrl = that.state.appMarketUrl;
        that.setState({appMarketUrl: '', isLoading: true});
        that.setState({appMarketUrl: '', isLoading: true});
        xhr.ontimeout = () => {
            that.setState({isLoading: false});
        };
        xhr.onerror = () => {
            that.setState({appMarketUrl: appMarketUrl, isLoading: false})
        };
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                that.setState({isLoading: false});
                try {
                    let res = JSON.parse(xhr.response);
                    let urlMatch = location.match(/\/download\/\w*\/config.json/i);
                    if (!!urlMatch && urlMatch.length > 0) {
                        const pkgName = urlMatch[0].substr(10, urlMatch[0].length - 22);
                        that.setState({
                            appName: res[pkgName].appName[that.state.language],
                            googlePlayUrl: res[pkgName].googlePlayUrl,
                            appMarketUrl: res[pkgName].appMarketUrl,
                            appStoreUrl: res[pkgName].appStoreUrl,
                        });
                        that.checkGooglePlay(res[pkgName].googlePlayUrl);
                        that.checkAppMarket(res[pkgName].appMarketUrl);
                    }
                } catch (e) {
                    that.checkGooglePlay(that.state.defaultGooglePlayUrl);
                    that.checkAppMarket(that.state.defaultAppMarketUrl);
                    console.error(e);
                }
            }
        };
        xhr.open('GET', location, true);
        xhr.send();
    }

    checkGooglePlay(url) {
        const that = this;
        let xhr = new XMLHttpRequest();
        xhr.timeout = 3000;
        const googlePlayUrl = url || that.state.googlePlayUrl;
        that.setState({googlePlayUrl: ''});
        xhr.onerror = () => {
            that.setState({googlePlayUrl: googlePlayUrl})
        };
        xhr.open('HEAD', googlePlayUrl, true);
        xhr.send();
    }

    checkAppMarket(url) {
        const that = this;
        let xhr = new XMLHttpRequest();
        xhr.timeout = 2000;
        const appMarketUrl = url || that.state.appMarketUrl;
        that.setState({appMarketUrl: ''});
        xhr.onerror = () => {
            that.setState({appMarketUrl: appMarketUrl})
        };
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
            }
        };
        xhr.open('HEAD', appMarketUrl, true);
        xhr.send();
    }

    render() {
        return (
            <div className="App">
                <div className="AppContainer">
                    <div className="AppNameContainer">
                        <span>{this.state.appName}</span>
                    </div>
                    <div onClick={e => this.handleDownload(e)} className="BtnContainer"
                         style={{display: this.state.appStoreUrl ? 'flex' : 'none'}}
                         data-url={this.state.appStoreUrl}>
                        <img className="BtnIcon" src={apple_store_icon} alt="apple_store_icon"/>
                        <span className="BtnTitle">App Store</span>
                        <img className="BtnDownloadIcon" src={download_icon} alt="download_icon"/>
                    </div>
                    <div onClick={e => this.handleDownload(e)} className="BtnContainer"
                         style={{display: this.state.appMarketUrl ? 'flex' : 'none'}}
                         data-url={this.state.appMarketUrl}>
                        <img className="BtnIcon" src={android_market_icon} alt="android_market_icon"/>
                        <span className="BtnTitle">App Market</span>
                        <img className="BtnDownloadIcon" src={download_icon} alt="download_icon"/>
                    </div>
                    <div onClick={e => this.handleDownload(e)} className="BtnContainer"
                         style={{display: this.state.googlePlayUrl ? 'flex' : 'none'}}
                         data-url={this.state.googlePlayUrl}>
                        <img className="BtnIcon" src={google_play_icon} alt="google_play_icon"/>
                        <span className="BtnTitle">Google Play</span>
                        <img className="BtnDownloadIcon" src={download_icon} alt="download_icon"/>
                    </div>
                </div>
                <div style={{display: this.state.isWeChatBrowser ? 'block' : 'none'}} className="openWithBrowserModal">
                    <div className="openWithBrowserRow">
                        <img src={arrow} className="openWithBrowserPic" alt="logo"/>
                        <span className="openWithBrowserSpan">请使用浏览器打开</span>
                    </div>
                </div>
                <div style={{display: this.state.isDownload || this.state.isLoading ? 'block' : 'none'}}
                     className="loaderModal">
                    <div className="loaderContainer">
                        <div className="loader"/>
                        <span style={{display: this.state.isDownload ? 'block' : 'none'}}>downloading</span>
                        <span style={{display: this.state.isLoading ? 'block' : 'none'}}>loading</span>
                    </div>
                </div>
            </div>
        );
    }

}

export default App;
